export const SEND_EMAIL_TIMER_DURATION = 5;
